<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Änderungen speichern ?" :loading="loading" :persistent="true"
                @ok="save" ok-text="Speichern"
                @cancel="discard" cancel-text="Verwerfen">
            Achtung! Es wurden Änderungen erkannt, die noch nicht gespeichert wurden.<br><br>
            Jetzt speichern?
            <template #button>
                <Button v-if="!hideCancel" :text="true" @click="$emit('cancel')" :color="ada.darkGrey">Abbrechen
                </Button>
            </template>
        </Dialog>
    </div>
</template>

<script>
import Dialog from "../../components/Dialog";
import Button from "../../components/buttons/Button";
import ada from "../../scss/ada_colors.scss";

export default {
    name: "SaveChangesDialog",
    props: {
        value: {},
        hideCancel: {
            type: Boolean, default: true,
        }
    },
    components: {Button, Dialog},
    data: () => {
        return {
            ada
        }
    },
    computed: {
        loading() {
            return this.$store.state.deploy.loading;
        }
    },
    methods: {
        save() {
            this.$emit('save');
        },
        discard() {
            this.$emit('discard');
            this.$emit('input', false);
        },
    }
}
</script>

<style scoped>

</style>